export enum SUPPORTED_METHODS {
  GET = 'GET',
  POST = 'POST',
  DELETE = 'DELETE',
  PUT = 'PUT',
  HEAD = 'HEAD',
}
